<template>
    <v-card>
        <v-toolbar flat dense color="blue-grey" dark>
            <v-toolbar-title>Historikk for denne bilen</v-toolbar-title>
        </v-toolbar>
        <v-progress-linear indeterminate v-if="loading"/>
        <p v-else-if="storages.length === 0" class="pa-3 text-center grey--text">Ingen tidligere dekklagringer
            funnet.</p>
        <v-list three-line v-else class="history-list">
            <template v-for="(item, index) in storages">
                <div>
                    <v-divider v-if="index > 0"/>
                    <v-list-item :key="item.id" :class="{'old-storage': !!item.out_at}"
                                 :to="{name: 'TireStorage', params:{id: carId, storage: item.id}}" exact>

                        <v-list-item-avatar>
                            <tire-type-icon :value="item.type"/>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-subtitle>
                                <small>
                                    <strong v-if="item.type === 'S'"
                                            class="orange--text text--darken-2">Sommerdekk</strong>
                                    <strong v-else-if="item.type === 'W'" class="grey--text">Piggfrie
                                        vinterdekk</strong>
                                    <strong v-else-if="item.type === 'WS'" class="grey--text">Piggdekk</strong>
                                    <strong v-else-if="item.type === 'A'" class="blue--text">Helårsdekk</strong>

                                    <strong v-if="item.km" class="black--text">&nbsp;({{ item.km }} km)</strong>
                                </small>
                            </v-list-item-subtitle>
                            <v-list-item-title>
                                {{ item.brand }}
                                <small class="grey--text text--darken-1">({{ item.size }})</small>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                {{ item.datesString }}
                                <strong class="yellow--text text--darken-4" v-if="!item.out_at">
                                    (lokasjon {{ item.location }})
                                </strong>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </div>
            </template>
        </v-list>
    </v-card>
</template>
<script>
    import {formatStorageTime} from "../../helpers";
    import TireTypeIcon from './TireTypeIcon';

    export default {
        name: 'tire-storage-history',
        props: {
            carId: Number
        },

        components: {
            TireTypeIcon
        },

        data() {
            return {
                loading: false,
                storages: []
            }
        },

        created() {
            this.loadData();
        },

        methods: {
            loadData() {
                this.loading = true;

                let params = {car: this.carId};

                this.$http.get('tire-storages', {params}).then(response => {
                    this.storages = response.data.data.map(it => {
                        return {
                            ...it,
                            datesString: formatStorageTime(it)
                        }
                    });

                    // Unless storage id is already set in URL, redirect to the appropriate page.
                    if (!this.$route.params.storage) {
                        let currentStorages = this.storages.filter(it => !it.out_at);
                        if (currentStorages.length > 0) {
                            let item = currentStorages[0];

                            this.$router.replace({
                                name: 'TireStorage',
                                params: {id: this.carId, storage: item.id}
                            })
                        } else {
                            this.$router.replace({
                                name: 'TireStorageEmpty',
                                params: {id: this.carId}
                            })
                        }
                    }

                }).finally(() => this.loading = false);
            }
        },
    }
</script>

<style scoped>
    .old-storage {
        opacity: 0.5;
    }

    .history-icon-invoiced {
        position: absolute;
        right: 10px;
        top: 10px;
        font-size: 70%;
    }
</style>
